import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext, useMemo, useState } from "react"
import Paper from "@material-ui/core/Paper"
import { AppContext } from "Views/Home/context"
import { CalendarProvider } from "./context"
import DateToolBar from "./DateToolBar"
import WeekSchedule from "./WeekSchedule"
import SpeciesWeekSchedule from "./SpeciesWeekSchedule"
import Calendar from "./Calendar"
import { SelectDateRange, EditMaterial } from "./context"
import { Board, BoardModifyDialog } from "Types/board"
import { useMark, useDateChange, useValueMap } from "Hooks/basic"
import { useFetchAdPlaces } from "Hooks/place"
import { useSubscribeBoard } from "Hooks/board"
import { checkUserPrivilege } from "Methods/privilege"
import BomDialog from "Components/Material/Dialog"
import HealthWeekSchedule from "./HealthWeekSchedule"
const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(4),
        userSelect: "none",
    },
}))

interface ComponentProps {
    channelName: string,
}
export default function Index(props: ComponentProps) {
    const { channelName } = props

    const classes = useStyles()
    const { date: currentDate, handleChangeDate: handleChangeCurrentDate, backToToday } = useDateChange(new Date())
    const { places } = useFetchAdPlaces(channelName)
    const { board } = useSubscribeBoard(channelName, currentDate)
    const { user, privilegeMap } = useContext(AppContext)
    const {
        mark: selectPlaceId,
        handleChangeMark: handleChangeSelectPlaceId,
        resetMark: resetPlaceId,
    } = useMark<number>(0)
    const { map, handleChangeMap } = useValueMap<BoardModifyDialog | null>(null)
    const isWeibo = channelName === "微博"
    const isWeChat = channelName === "微信"
    const isChildCalendar = channelName === "子账号"
    const isSpecies = channelName === "果壳自然"
    const isHealth = channelName === '果壳病人'
    if (isWeChat) {
        places.pop()
    }
    const privilege = useMemo(() => {
        const boardInsertPrivilege = checkUserPrivilege(privilegeMap, "board")
        const weChatBoardInsertPrivilege = checkUserPrivilege(privilegeMap, "wechat_board")

        const { department: { type_name = '' } = {} } = user || {}

        // 子账号日历只有商务的点位运营才可以增加新条目
        if (isChildCalendar) {
            return type_name === 'business' ? { ...boardInsertPrivilege } : {
                ...boardInsertPrivilege,
                update: false,
                insert: false,
                delete: false,
            }
        }

        if (isWeChat) return weChatBoardInsertPrivilege

        return boardInsertPrivilege
    }, [privilegeMap, isWeChat])
    const [movableBoard, setMovableBoard] = useState<Board | null>(null)
    const handleSetMovableBoard = (board: Board | null) => {
        setMovableBoard(board)
    }
    const [selectDateRange, setSelectDateRange] = useState<SelectDateRange | null>(null)
    const handleSetSelectDateRange = (range: SelectDateRange | null) => {
        setSelectDateRange(range)
    }
    const [editMaterial, setEditMaterial] = useState<EditMaterial>({
        modifyData: null,
        open: false,
        update: false,
        isBom: false,
        handleClose: () => { },
        handleConfirm: () => { },
    })
    const handleSetEditMaterial = (material: EditMaterial) => {
        setEditMaterial(material)
    }
    return (
        <CalendarProvider value={{
            currentDate,
            handleChangeCurrentDate,
            backToToday,
            places,
            board,
            channelName,
            privilegeMap,
            selectPlaceId,
            handleChangeSelectPlaceId,
            resetPlaceId,
            selectDateRange,
            handleSetSelectDateRange,
            boardModifyDialog: map,
            handleChangeBoardModifyDialog: handleChangeMap,
            isWeChat,
            isWeibo,
            isSpecies,
            isHealth,
            privilege,
            movableBoard,
            handleSetMovableBoard,
            editMaterial,
            handleSetEditMaterial,
        }}>
            <Paper className={classes.root}>
                {isWeChat ? <WeekSchedule /> : null}
                {isSpecies ? <SpeciesWeekSchedule /> : null}
                {isHealth ? <HealthWeekSchedule /> : null}
                <DateToolBar />
                <Calendar />
            </Paper>
            <BomDialog {...editMaterial} />
        </CalendarProvider>
    )
}
